<template>
    <div class="gray-bg">
        <div class="register-box">
            <h6 class="title">账号信息</h6>
            <form>
                <ul class="register-ul">
                    <li class="clearfix register-li">
                        <input type="text" class="registerInput" placeholder="手机号" v-model="mobilePhone">
                    </li>
                    <li class="clearfix register-li code-li">
                        <input type="text" class="registerInput" placeholder="验证码" v-model="code">
                        <span class="codeBtn" @click="codeBtn()">点击获取验证码</span>
                    </li>
                    <li class="clearfix register-li hide register-password">
                        <input type="password" class="registerInput" :placeholder="passwordText" v-model="password">
                    </li>
                    <li class="clearfix register-li">
                        <p class="clearfix"><span class="forget fr" @click="forget()">忘记密码</span></p>
                        <div class="confirmBtn" @click="confir()">确定</div>
                    </li>
                </ul>
            </form>
        </div>
        
    </div>
</template>
<script>
// import Top from '@/components/public/top'
import crypto from 'crypto'

export default {
    name: 'cooperation-pro',
    data () {
        return {
            sendSelected:'',
            colourClass:'white',
            passwordText:'输入密码',
            mobilePhone:'',
            code:'',
            password:'',
        }
    },
    computed:{
        Code(){ // 提交手机号，获取验证码
            return this.$store.state.interface.Code;
        },
        login(){ // 登录
            return this.$store.state.interface.login;
        },
    },
    methods:{
        forget(){ //忘记密码
            this.$layer.msg('请到客户端更改密码！');
        },
        codeBtn(){ //获取验证码
            var self = this,
            times,
            number=59;
            
            if($('.codeBtn').hasClass('gray')){
                return false
            }
            var pattern=/^1[35789]\\d{9}$/;
            if(this.mobilePhone == ''){
                self.$layer.msg('手机号码不能为空');
                return false
            }else if(!(/^1(3|4|5|7|8)\d{9}$/.test(this.mobilePhone))){
                self.$layer.msg('请填写正确的手机号码');
                return false
            }
            $('.codeBtn').html('60秒后再获取').addClass('gray');
            times=setInterval(function(){
                $('.codeBtn').html(number+'秒后再获取')
                number--;
                if(number==0){
                    clearInterval(times);
                    $('.codeBtn').removeClass('gray').html('点击获取验证码')
                }
            },1000)
            event.preventDefault();
            var formData =new FormData(); // 手机
                formData.append('mobilePhone', this.mobilePhone);
                formData.append('app', 'liexing');
                formData.append('platform', 'web');
                formData.append('ver', 3);

            this.$ajax.post(this.Code,formData).then(function(res) {
                
                if(res.data.code == '10000'){
                    self.$layer.msg('已发送验证码到您的⼿手机，请注意查收');
                    var state=res.data.result.Delete.id;
                    $('.register-password').show();
                    if(state==0){
                        self.passwordText="请设置密码";
                    }else{
                        $('.forget').show();
                    }
                }else if(res.data.code == '14001'){
                    self.$layer.msg('电话号码不能为空');
                }else if(res.data.code == '14002'){
                    self.$layer.msg('您已经是达⼈人，请不要重复认证。');
                }else if(res.data.code == '14003'){
                    self.$layer.msg('您已经是供应商，请不要重复认证。');
                }else if(res.data.code == '14004'){
                    self.$layer.msg('发送验证码失败，请检查号码后重试。');
                }else{
                    self.$layer.msg('数据错误，请刷新后重试');
                }
            },function(res) {
                self.$layer.msg('数据错误，请刷新后重试');
            });
        },

        confir(){
            var self = this;
            var pattern=/^1[35789]\\d{9}$/;
            if(this.mobilePhone == ''){
                self.$layer.msg('手机号码不能为空');
                return false
            }else if(!(/^1(3|4|5|7|8)\d{9}$/.test(this.mobilePhone))){
                self.$layer.msg('请填写正确的手机号码');
                return false
            }else if(this.code==''){
                self.$layer.msg('请输入验证码');
                return false
            }else if(this.code.length < 4){
                self.$layer.msg('验证码错误');
                return false
            }else if(this.password==''){
                self.$layer.msg('请输入密码');
                return false
            }else if(this.password.length < 6){
                self.$layer.msg('密码长度6位数以上');
                return false
            }

            event.preventDefault();
            let md5 = crypto.createHash('md5').update(self.password, 'utf-8').digest('hex');
            let codemd5 = crypto.createHash('md5').update(self.code, 'utf-8').digest('hex');
            var formData =new FormData(); // 登录
                formData.append('mobilePhone', this.mobilePhone);//手机
                formData.append('code', codemd5);//验证码
                formData.append('pass', md5);//密码
                formData.append('app', 'liexing');
                formData.append('platform', 'web');
                formData.append('ver', 3);
            this.$ajax.post(this.login,formData).then(function(res) {
                
                if(res.data.code == '10000'){
                    var customer = res.data.result.Delete;                           
                    sessionStorage.setItem("GWcustomer",JSON.stringify(customer));

                    if(self.sendSelected=='cooperation'){
                        self.$router.push({ path: '/cooperation/information' })
                    }else if(self.sendSelected=='league'){
                        self.$router.push({ path: '/league/information' })
                    }
                }else if(res.data.code == '14001'){
                    self.$layer.msg('参数错误');
                }else if(res.data.code == '14002'){
                    self.$layer.msg('您已经是达⼈人，请不不要重复认证。');
                }else if(res.data.code == '14003'){
                    self.$layer.msg('您已经是供应商，请不不要重复认证。');
                }else if(res.data.code == '14004'){
                    self.$layer.msg('您输⼊入的密码或验证码有误。');
                }else if(res.data.code == '14005'){
                    self.$layer.msg('您输⼊入的密码或验证码有误。');
                }else if(res.data.code == '14006'){
                    self.$layer.msg('您输⼊入的密码或验证码有误。');
                }else{
                    self.$layer.msg('数据错误，请刷新后重试');
                }
            },function(res) {
                self.$layer.msg('数据错误，请刷新后重试');
            });
        }
    },
    
    mounted(){
        var Url = window.location.href;
        // console.log(Url)
        var UrlPath=Url.split('/');
        for(var i in UrlPath){
            if(UrlPath[i]=='cooperation'){
                this.sendSelected='cooperation';
            }else if(UrlPath[i]=='league'){
                this.sendSelected='league';
            }
        }
        this.$emit('nav',this.sendSelected,this.colourClass);
    }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.register-box{
    width: 800px;
    padding: 40px;
    padding-top: 15px;
    background-color: #fff;
    margin: 0 auto;
    .title{
        font-size: 22px;
        line-height: 48px;
        color: #333;
        border-bottom: 1px solid #ddd;
        padding-bottom: 5px;
        margin-bottom: 40px;
    }
    .register-ul{
        width: 410px;
        margin: 40px auto 0;
        .register-li{
            margin-bottom: 30px;
            &.code-li{
                position: relative;
                .codeBtn{
                    position: absolute;
                    height: 38px;
                    line-height: 38px;
                    right: 1px;
                    top: 1px;
                    color: #ff8c00;
                    font-size: 14px;
                    cursor: pointer;
                    padding: 0 20px;
                    background-color: #fff;
                    border-radius: 6px;
                    &.gray{
                        caption:inherit;
                        color: #999;
                    }
                }
            }
            .registerInput{
                width: 100%;
                height: 40px;
                line-height: 40px;
                border: 1px solid #ddd;
                border-radius: 6px;
                padding: 0 15px;
                box-sizing: border-box;
                color: #333;
            }
            .mistake{
                color: #ff0000;
                font-size: 12px;
                padding: 5px 15px;
                display: none;
            }
            .confirmBtn{
                width: 100%;
                height: 50px;
                font-size: 16px;
                line-height: 50px;
                border-radius: 6px;
                padding: 0 15px;
                box-sizing: border-box;
                background-color: #ff8c00;
                color: #fff;
                text-align: center;
                cursor: pointer;
                &:hover{
                    background-color: #ff9a1f;
                }
            }
            .forget{
                color:#ff0000;
                font-size: 14px;
                margin-bottom: 5px;
                cursor: pointer;
                display: none;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/cooperation/register.vue